
import { axios, BaseApiUrl } from './axios_config';

// 构建授权链接
export const getWeixinAuthUrl = params => {
    return axios.get(`${BaseApiUrl}/workwx/getAuthUrl`, { params: params }).then(res => res.data);
};

export const weixinAuth = params => {
    return axios.get(`http://cwms.xiyou56.com/wms/api/workwx/authxy`, { params: params }).then(res => res.data);
};

export const weixinAuthxy = params => {
    return axios.get(`${BaseApiUrl}/workwx/authxy`, { params: params }).then(res => res.data);
};

export const getJsApiConfig = params => {
    return axios.get(`${BaseApiUrl}/workwx/getJsApiConfig`, { params: params }).then(res => res.data);
};
